import { lgMarginBottomStyles } from "../../neutral/styles/spacing";
import PageContentSeparator from "./PageContentSeparator";
import { css } from "@emotion/react";
import { MediumHeadline } from "@minted/fancyclothes";
import React from "react";

type PageTitleProps = {
  title: string;
};

const PageTitle = ({ title }: PageTitleProps) => (
  <div
    css={css`
      text-align: center;
    `}
  >
    <div css={lgMarginBottomStyles} data-cy="heading">
      <MediumHeadline>{title}</MediumHeadline>
    </div>
    <PageContentSeparator />
  </div>
);

export default PageTitle;
